var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9858 5.98731C15.9858 8.18944 14.1971 9.97462 11.9906 9.97462C9.78405 9.97462 7.9953 8.18944 7.9953 5.98731C7.9953 3.78518 9.78405 2 11.9906 2C14.1971 2 15.9858 3.78518 15.9858 5.98731Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3704 12.9098C17.8828 13.3964 17.8828 14.1853 18.3704 14.6719C18.858 15.1585 19.6485 15.1585 20.1361 14.6719C20.6237 14.1853 20.6237 13.3964 20.1361 12.9098C19.6485 12.4232 18.858 12.4232 18.3704 12.9098ZM16.8544 15.1276C16.2698 14.0839 16.422 12.7397 17.311 11.8525C18.3837 10.7819 20.1228 10.7819 21.1955 11.8525C22.2682 12.923 22.2682 14.6587 21.1955 15.7292C20.3065 16.6165 18.9596 16.7684 17.9138 16.1849L16.2804 17.815L17.1633 18.6961C17.4558 18.9881 17.4558 19.4614 17.1633 19.7534C16.8707 20.0454 16.3964 20.0454 16.1038 19.7534L15.221 18.8723L14.2487 19.8427L15.1316 20.7237C15.4241 21.0157 15.4241 21.4891 15.1316 21.781C14.839 22.073 14.3647 22.073 14.0722 21.781L12.6596 20.3713C12.3671 20.0793 12.3671 19.606 12.6596 19.314L16.8544 15.1276Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4198 11.9683H5.99764C4.89437 11.9683 4 12.8609 4 13.9619C4 18.3662 7.5775 21.9366 11.9906 21.9366C12.0299 21.9366 12.0692 21.9363 12.1083 21.9357L11.6002 21.4286C10.7226 20.5527 10.7226 19.1326 11.6002 18.2567L15.1175 14.7465C14.9037 13.8217 15.0042 12.839 15.4198 11.9683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserKey);
export default __webpack_public_path__ + "static/media/user-key.d64721b977cfd7c1a0beddfd53307d25.svg";
export { ForwardRef as ReactComponent };